"use client";

import classNames from "classnames";
import { ReactNode } from "react";
import ReactModal from "react-modal";

import styles from "./Modal.module.css";

ReactModal.setAppElement("#__next");

const Modal: React.FC<ModalProps> = ({
  title,
  children,
  actions,
  size = "s",
  className,
  onRequestClose,
}) => (
  <ReactModal
    isOpen={true}
    className={classNames(styles.modal, className, {
      [styles.modalSizeM]: size === "m",
    })}
    overlayClassName={styles.overlay}
    bodyOpenClassName={styles.modalOpenBody}
    onRequestClose={onRequestClose}
  >
    {title && <h1 className={styles.title}>{title}</h1>}
    <div className={styles.content}>{children}</div>
    {actions && <div className={styles.actions}>{actions}</div>}
  </ReactModal>
);

export default Modal;

export type ModalProps = {
  children?: ReactNode;
  title?: string;
  actions?: ReactNode;
  size?: "s" | "m";
  className?: string;
  onRequestClose?: () => void;
};
